import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import {
  getTenantTeamMembers,
  modifyContactUsers,
} from '../contacts.resource.js';
import { forceBustCache } from 'fetcher!sofe';
import canopyUrls from 'canopy-urls!sofe';
import { successToast } from 'toast-service!sofe';
import { catchAsyncStacktrace } from 'auto-trace';
import { CprButton, CprLoader } from 'canopy-styleguide!sofe';
import TeamMember from './team-member.component.js';
import DropDownFilter from './drop-down-filter.component.js';
import DropDownSelectAll from './drop-down-select-all.component.js';

export default class DropDownTeammembers extends React.Component {
  constructor(props) {
    super(props);
    this.closeDropDown = e => {
      if (!e.popeyes) {
        this.props.closeDropDown();
      }
    };
    this.preventClose = e => {
      e.popeyes = true;
    };
    this.state = {
      filter: '',
      teamMembers: [],
    };
    this.inSearchResults = teamMember => {
      return teamMember.name.toLowerCase().includes(this.state.filter);
    };
  }
  componentWillMount() {
    getTenantTeamMembers().subscribe(teamMembers => {
      this.setState({
        teamMembers: teamMembers.map(teamMember => {
          if (
            this.props.teamMembers.find(
              existingMember => existingMember.id === teamMember.id
            )
          ) {
            return { ...teamMember, selected: true };
          } else {
            return teamMember;
          }
        }),
      });
    }, catchAsyncStacktrace());
  }
  componentDidMount() {
    document.addEventListener('click', this.closeDropDown);
    this.dropDown.addEventListener('click', this.preventClose);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.closeDropDown);
    this.dropDown.removeEventListener('click', this.preventClose);
  }
  render() {
    const someSelected = this.state.teamMembers.some(
      teamMember => teamMember.selected
    );
    const filtered = this.state.teamMembers.filter(this.inSearchResults);
    return (
      <div
        onClick={e => {
          e.stopPropagation();
        }}
        ref={ref => (this.dropDown = ref)}
        className={`${css(styles.dropDown)} cps-card`}>
        <div className={`${css(styles.header)}`}>
          <div className={`cps-subheader-sm`}>Manage Team Members</div>
        </div>

        <div className={`${css(styles.body)}`}>
          <DropDownFilter setFilter={text => this.setState({ filter: text })} />
          {!!this.state.teamMembers.length ? (
            <DropDownSelectAll
              checked={filtered.every(teamMember => teamMember.selected)}
              toggleSelectAll={checked => {
                this.setState({
                  teamMembers: this.state.teamMembers.map(teamMember => ({
                    ...teamMember,
                    selected: filtered.includes(teamMember)
                      ? checked
                      : teamMember.selected,
                  })),
                });
              }}
            />
          ) : (
            <div>
              <CprLoader />
            </div>
          )}
          <div className={`${css(styles.teamMembers)}`}>
            {filtered.map(teamMember => {
              return (
                <TeamMember
                  key={teamMember.id}
                  initials={teamMember.initials}
                  name={teamMember.name}
                  selectTeamMember={this.selectTeamMember.bind(
                    this,
                    teamMember.id
                  )}
                  selected={teamMember.selected}
                />
              );
            })}
          </div>
          {this.props.hasAccess('company_settings_team_members') && (
            <a onClick={this.inviteTeamMember.bind(this)}>
              + Create a new team member
            </a>
          )}
        </div>
        <div
          className={`cps-bg-gray-4`}
          style={{
            display: 'flex',
            padding: '16px',
            borderTop: '1px solid #e9e9e9',
          }}>
          <CprButton onClick={this.done.bind(this)} actionType="primary">
            {!this.state.sending ? 'Done' : 'Sending...'}
          </CprButton>
          <CprButton onClick={this.props.closeDropDown} actionType="flat">
            Cancel
          </CprButton>
        </div>
      </div>
    );
  }
  inviteTeamMember() {
    SystemJS.import('invite-team-member!sofe')
      .then(({ inviteTeamMember }) => {
        inviteTeamMember({
          clientId: this.props.contactId,
          isFreeTrial: window.tenant.is_trial,
          closeCallback: () => {
            forceBustCache(
              `${canopyUrls.getWorkflowUrl()}/api/clients/${
                this.props.contactId
              }`
            );
          },
        });
      })
      .catch(catchAsyncStacktrace());
  }
  done() {
    if (this.state.sending) return;
    const { removed, added } = getRemovedAdded(
      this.state.teamMembers,
      this.props.teamMembers
    );
    if (removed.length || added.length) {
      this.setState({
        sending: true,
      });
      modifyContactUsers(
        this.props.contactId,
        this.state.teamMembers.filter(tm => tm.selected).map(tm => tm.id),
        added.map(tm => tm.id)
      ).subscribe(response => {
        // If you removed yourself and are not an admin, take you to the list page
        if (
          !this.props.hasAccess('contacts_not_assigned') &&
          removed.find(tm => tm.id === window.loggedInUser.id)
        ) {
          window.location.hash = '#/clients';
          return;
        }
        const addMessage = `${
          added.length > 1 ? 'Notifications have' : 'A notification has'
        } been sent to ${added.map(tm => tm.name).join(', ')}`;
        const removedMessage = `${removed.map(tm => tm.name).join(', ')} ${
          removed.length > 1 ? 'have' : 'has'
        } been removed from this contact.`;
        successToast(
          `${added.length ? addMessage : ''}.${
            added.length && removed.length ? '\nand\n' : ''
          }${removed.length ? removedMessage : ''}`
        );
        forceBustCache(
          `${canopyUrls.getWorkflowUrl()}/api/clients/${this.props.contactId}`
        );
        this.props.closeDropDown();
      }, catchAsyncStacktrace());
    } else {
      this.props.closeDropDown();
    }
  }
  selectTeamMember(id) {
    this.setState({
      teamMembers: this.state.teamMembers.map(teamMember => {
        if (teamMember.id === id) {
          return { ...teamMember, selected: !teamMember.selected };
        }
        return teamMember;
      }),
    });
  }
}

export function getRemovedAdded(newSelection, oldSelection) {
  return newSelection.reduce(
    (total, curr) => {
      if (curr.selected && !oldSelection.find(tm => tm.id === curr.id)) {
        return { added: [...total.added, curr], removed: total.removed };
      }
      if (!curr.selected && oldSelection.find(tm => tm.id === curr.id)) {
        return { added: total.added, removed: [...total.removed, curr] };
      }
      return total;
    },
    { removed: [], added: [] }
  );
}

const styles = StyleSheet.create({
  dropDown: {
    position: 'absolute',
    top: 'calc(100% + 16px)',
    width: '352px',
    right: 0,
    zIndex: '10',
    cursor: 'default',
    fontWeight: 500,
  },
  checkbox: {
    display: 'flex',
    justifyContent: 'start',
    marginBottom: '16px',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1.6rem',
    borderBottom: '1px solid #dfdfdf',
  },
  body: {
    padding: '16px',
    textAlign: 'left',
  },
  teamMembers: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxHeight: '260px',
    overflowY: 'auto',
  },
});
